import React from 'react';

export const ShutterCenterOpeningPostCenterOpening = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 135.84 59.3"
      width="136"
      {...props}
    >
      <g data-name="Group 83-2">
        <g data-name="Group 483">
          <path
            data-name="Rectangle 166"
            fill="#fff"
            d="M5.49.59h124.85v50.8H5.49z"
          />
          <path
            data-name="Path 2322"
            d="M4.72 51.4V.59A.71.71 0 015.49 0h124.86a.71.71 0 01.77.59V51.4c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM129.58 1.18H6.26v49.63h123.32z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 484">
          <path
            data-name="Rectangle 167"
            fill="#fff"
            d="M5.49.59h124.85v50.8H5.49z"
          />
          <path
            data-name="Path 2323"
            d="M4.72 51.4V.59A.71.71 0 015.49 0h124.86a.71.71 0 01.77.59V51.4c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM129.58 1.18H6.26v49.63h123.32z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 485" fill="#dcd9d5">
          <path data-name="Rectangle 168" d="M9.9 3.94h116.04v44.1H9.9z" />
          <path
            data-name="Path 2324"
            d="M9.89 48.63c-.42 0-.77-.26-.76-.58V3.94c0-.32.34-.58.77-.58h116c.42 0 .77.26.77.58V48c0 .32-.35.58-.77.58H9.89zm115.28-44.1H10.67v42.93h114.5z"
          />
        </g>
        <path
          data-name="Path 2325"
          d="M.73 52h134.38c.4 0 .73-.25.73-.55a.66.66 0 00-.73-.56H.73a.65.65 0 00-.73.51c0 .3.33.6.73.6z"
          fill="#dcd9d5"
        />
      </g>
      <g data-name="Group 84">
        <g data-name="Group 486">
          <path
            data-name="Rectangle 169"
            fill="#233762"
            d="M69.54 2.25l27.14 6.3.12 49.99-27.26-6.8V2.25z"
          />
          <path
            data-name="Path 2326"
            d="M97.29 59.3l-28.23-7V1.52L97.17 8zM70 51.24l26.29 6.55-.09-48.73L70 3z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 487">
          <path
            data-name="Rectangle 170"
            fill="#233762"
            d="M72.41 8.13l21.54 5.06.01 3.58-21.55-5.07V8.13z"
          />
          <path
            data-name="Path 2327"
            d="M94.21 17.15l-22-5.2V7.76l22 5.16zm-21.55-5.72l21 4.95v-2.94l-21-4.92z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 488">
          <path
            data-name="Rectangle 171"
            fill="#233762"
            d="M72.41 11.7l21.55 5.07.01 3.59-21.56-5.12V11.7z"
          />
          <path
            data-name="Path 2328"
            d="M94.22 20.73l-22.06-5.22v-4.2l22 5.19zM72.66 15l21 5v-3l-21-5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 489">
          <path
            data-name="Rectangle 172"
            fill="#233762"
            d="M72.41 15.26l21.56 5.1v3.58L72.41 18.8v-3.54z"
          />
          <path
            data-name="Path 2329"
            d="M94.23 24.33l-22.07-5.26v-4.21l22.06 5.22zm-21.57-5.79l21.06 5v-2.93l-21.06-5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 490">
          <path
            data-name="Rectangle 173"
            fill="#233762"
            d="M72.41 18.84l21.57 5.13v3.59l-21.57-5.17v-3.55z"
          />
          <path
            data-name="Path 2330"
            d="M94.24 28l-22.08-5.34v-4.21l22.07 5.26zm-21.58-5.86l21.07 5v-2.91l-21.06-5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 491">
          <path
            data-name="Rectangle 174"
            fill="#233762"
            d="M72.41 22.39l21.57 5.17.01 3.59-21.57-5.19-.01-3.57z"
          />
          <path
            data-name="Path 2331"
            d="M94.25 31.54l-22.08-5.31V22l22.08 5.27zM72.66 25.7l21.08 5.06v-2.94l-21.07-5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 492">
          <path
            data-name="Rectangle 175"
            fill="#233762"
            d="M72.42 25.96l21.57 5.19.01 3.59-21.58-5.21v-3.57z"
          />
          <path
            data-name="Path 2332"
            d="M94.25 35.13l-22.08-5.34v-4.21l22.07 5.31zm-21.58-5.86l21.07 5.09v-2.94l-21.08-5.07z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 493">
          <path
            data-name="Rectangle 176"
            fill="#233762"
            d="M72.42 29.53L94 34.74l.01 3.6-21.59-5.24v-3.57z"
          />
          <path
            data-name="Path 2333"
            d="M94.26 38.73l-22.09-5.37v-4.21l22.08 5.33zm-21.59-5.9L93.75 38v-3l-21.08-5.1z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 494">
          <path
            data-name="Rectangle 177"
            fill="#233762"
            d="M72.42 33.1l21.59 5.24v3.6l-21.59-5.27V33.1z"
          />
          <path
            data-name="Path 2334"
            d="M94.27 42.33l-22.1-5.4v-4.22l22.09 5.37zm-21.6-5.93l21.09 5.15v-2.94l-21.09-5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 495">
          <path
            data-name="Rectangle 178"
            fill="#233762"
            d="M72.42 36.67l21.59 5.27.01 3.6-21.6-5.3v-3.57z"
          />
          <path
            data-name="Path 2335"
            d="M94.28 45.93L72.17 40.5v-4.22l22.1 5.4zM72.67 40l21.1 5.17v-3L72.67 37z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 496">
          <path
            data-name="Rectangle 179"
            fill="#233762"
            d="M72.42 40.26l21.6 5.3.01 3.61-21.61-5.33v-3.58z"
          />
          <path
            data-name="Path 2336"
            d="M94.28 49.56L72.17 44.1v-4.22l22.11 5.42zm-21.61-6l21.11 5.2v-3l-21.1-5.18z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 497">
          <path
            data-name="Rectangle 180"
            fill="#233762"
            d="M72.42 43.84l21.61 5.33.01 3.6-21.62-5.36v-3.57z"
          />
          <path
            data-name="Path 2337"
            d="M94.29 53.16l-22.12-5.48v-4.23l22.11 5.45zm-21.62-6l21.11 5.23v-3l-21.11-5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 181"
          fill="#fff"
          d="M82.53 10.52l1.41.33.05 39.43-1.41-.35-.05-39.41z"
        />
      </g>
      <g data-name="Group 85">
        <g data-name="Group 498">
          <path
            data-name="Rectangle 182"
            fill="#233762"
            d="M39.53 8.28l27.79-6.03v49.49l-27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338"
            d="M67.81 52.25L39 59.3V7.75l28.81-6.23zM40 57.79l26.8-6.55V3L40 8.79z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499">
          <path
            data-name="Rectangle 183"
            fill="#233762"
            d="M42.54 12.94l22.04-4.85v3.56l-22.04 4.9v-3.61z"
          />
          <path
            data-name="Path 2339"
            d="M64.83 11.92l-22.55 5v-4.26l22.55-4.95zm-22 4.23l21.53-4.77V8.46L42.8 13.2z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500">
          <path
            data-name="Rectangle 184"
            fill="#233762"
            d="M42.54 16.55l22.04-4.9v3.57l-22.04 4.94v-3.61z"
          />
          <path
            data-name="Path 2340"
            d="M64.83 15.48l-22.55 5.06v-4.27l22.55-5zm-22 4.28L64.33 15v-3L42.8 16.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501">
          <path
            data-name="Rectangle 185"
            fill="#233762"
            d="M42.54 20.16l22.04-4.94v3.58l-22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341"
            d="M64.83 19.05l-22.55 5.11v-4.28l22.55-5zm-22 4.34l21.53-4.87V15.6L42.8 20.42z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502">
          <path
            data-name="Rectangle 186"
            fill="#233762"
            d="M42.54 23.8l22.04-4.98v3.57l-22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342"
            d="M64.83 22.65L42.28 27.8v-4.27l22.55-5.1zM42.8 27l21.53-4.9v-2.91L42.8 24.07z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503">
          <path
            data-name="Rectangle 187"
            fill="#233762"
            d="M42.54 27.41l22.04-5.02v3.57l-22.04 5.06v-3.61z"
          />
          <path
            data-name="Path 2343"
            d="M64.83 26.22l-22.55 5.19v-4.27L64.83 22zm-22 4.41l21.53-4.94v-2.92L42.8 27.68z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504">
          <path
            data-name="Rectangle 188"
            fill="#233762"
            d="M42.54 31.02l22.04-5.06v3.56l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344"
            d="M64.83 29.79L42.28 35v-4.25l22.55-5.18zm-22 4.46l21.53-5v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505">
          <path
            data-name="Rectangle 189"
            fill="#233762"
            d="M42.54 34.63l22.04-5.11v3.57l-22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345"
            d="M64.83 33.35l-22.55 5.28v-4.26l22.55-5.23zm-22 4.51l21.53-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506">
          <path
            data-name="Rectangle 190"
            fill="#233762"
            d="M42.54 38.24l22.04-5.15v3.57l-22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346"
            d="M64.83 36.92l-22.55 5.33V38l22.55-5.3zm-22 4.55l21.53-5.08v-2.92l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507">
          <path
            data-name="Rectangle 191"
            fill="#233762"
            d="M42.54 41.86l22.04-5.2v3.56l-22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347"
            d="M64.83 40.49l-22.55 5.37v-4.27l22.55-5.31zm-22 4.59L64.33 40v-3L42.8 42.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508">
          <path
            data-name="Rectangle 192"
            fill="#233762"
            d="M42.54 45.49l22.04-5.24v3.57l-22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348"
            d="M64.83 44.08L42.28 49.5v-4.27l22.55-5.36zm-22 4.64l21.53-5.17v-2.92L42.8 45.76z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509">
          <path
            data-name="Rectangle 193"
            fill="#233762"
            d="M42.54 49.11l22.04-5.29v3.57l-22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349"
            d="M64.83 47.65l-22.55 5.46v-4.27l22.55-5.41zm-22 4.68l21.53-5.21V44.2L42.8 49.37z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194"
          fill="#fff"
          d="M53 10.63l1.44-.32v39.53l-1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-2">
        <g data-name="Group 498-2">
          <path
            data-name="Rectangle 182-2"
            fill="#233762"
            d="M100.92 8.28l27.8-6.03v49.49l-27.8 6.8V8.28z"
          />
          <path
            data-name="Path 2338-2"
            d="M129.21 52.25l-28.79 7V7.75l28.79-6.23zm-27.78 5.54l26.81-6.55V3l-26.81 5.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-2">
          <path
            data-name="Rectangle 183-2"
            fill="#233762"
            d="M103.94 12.94l22.04-4.85v3.56l-22.04 4.9v-3.61z"
          />
          <path
            data-name="Path 2339-2"
            d="M126.23 11.92l-22.56 5v-4.26l22.56-4.95zm-22 4.23l21.54-4.77V8.46l-21.58 4.74z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-2">
          <path
            data-name="Rectangle 184-2"
            fill="#233762"
            d="M103.94 16.55l22.04-4.9v3.57l-22.04 4.94v-3.61z"
          />
          <path
            data-name="Path 2340-2"
            d="M126.23 15.48l-22.56 5.06v-4.27l22.56-5zm-22 4.28l21.5-4.76v-3l-21.54 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-2">
          <path
            data-name="Rectangle 185-2"
            fill="#233762"
            d="M103.94 20.16l22.04-4.94v3.58l-22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-2"
            d="M126.23 19.05l-22.56 5.11v-4.28l22.56-5zm-22 4.34l21.54-4.87V15.6l-21.54 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-2">
          <path
            data-name="Rectangle 186-2"
            fill="#233762"
            d="M103.94 23.8l22.04-4.98v3.57l-22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342-2"
            d="M126.23 22.65l-22.56 5.15v-4.27l22.56-5.1zm-22 4.37l21.54-4.9v-2.93l-21.54 4.88z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-2">
          <path
            data-name="Rectangle 187-2"
            fill="#233762"
            d="M103.94 27.41l22.04-5.02v3.57l-22.04 5.06v-3.61z"
          />
          <path
            data-name="Path 2343-2"
            d="M126.23 26.22l-22.56 5.19v-4.27L126.23 22zm-22 4.41l21.54-4.94v-2.92l-21.54 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-2">
          <path
            data-name="Rectangle 188-2"
            fill="#233762"
            d="M103.94 31.02l22.04-5.06v3.56l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-2"
            d="M126.23 29.79L103.67 35v-4.25l22.56-5.18zm-22 4.46l21.54-5v-2.91l-21.54 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-2">
          <path
            data-name="Rectangle 189-2"
            fill="#233762"
            d="M103.94 34.63l22.04-5.11v3.57l-22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-2"
            d="M126.23 33.35l-22.56 5.28v-4.26l22.56-5.23zm-22 4.51l21.54-5v-3l-21.54 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-2">
          <path
            data-name="Rectangle 190-2"
            fill="#233762"
            d="M103.94 38.24l22.04-5.15v3.57l-22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-2"
            d="M126.23 36.92l-22.56 5.33V38l22.56-5.27zm-22 4.55l21.54-5.08v-2.92l-21.54 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-2">
          <path
            data-name="Rectangle 191-2"
            fill="#233762"
            d="M103.94 41.86l22.04-5.2v3.56l-22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-2"
            d="M126.23 40.49l-22.56 5.37v-4.27l22.56-5.31zm-22 4.59l21.5-5.08v-3l-21.54 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-2">
          <path
            data-name="Rectangle 192-2"
            fill="#233762"
            d="M103.94 45.49l22.04-5.24v3.57l-22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-2"
            d="M126.23 44.08l-22.56 5.42v-4.27l22.56-5.36zm-22 4.64l21.54-5.17v-2.92l-21.54 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-2">
          <path
            data-name="Rectangle 193-2"
            fill="#233762"
            d="M103.94 49.11l22.04-5.29v3.57l-22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-2"
            d="M126.23 47.65l-22.56 5.46v-4.27l22.56-5.41zm-22 4.68l21.54-5.21V44.2l-21.54 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-2"
          fill="#fff"
          d="M114.39 10.63l1.44-.32v39.53l-1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-3">
        <g data-name="Group 498-3">
          <path
            data-name="Rectangle 182-3"
            fill="#233762"
            d="M35.01 8.28L7.22 2.25v49.49l27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338-3"
            d="M6.74 1.52l28.77 6.23V59.3l-28.77-7zm27.77 7.27L7.71 3v48.24l26.8 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-3">
          <path
            data-name="Rectangle 183-3"
            fill="#233762"
            d="M32.01 12.94L9.97 8.09v3.56l22.04 4.9v-3.61z"
          />
          <path
            data-name="Path 2339-3"
            d="M9.71 7.71l22.56 5V17L9.71 12zm22 5.49L10.22 8.46v2.92l21.53 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-3">
          <path
            data-name="Rectangle 184-3"
            fill="#233762"
            d="M32.01 16.55l-22.04-4.9v3.57l22.04 4.94v-3.61z"
          />
          <path
            data-name="Path 2340-3"
            d="M9.71 11.27l22.56 5v4.27L9.71 15.48zm22 5.54L10.22 12v3l21.53 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-3">
          <path
            data-name="Rectangle 185-3"
            fill="#233762"
            d="M32.01 20.16L9.97 15.22v3.58l22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-3"
            d="M9.71 14.84l22.56 5v4.28L9.71 19.05zm22 5.58L10.22 15.6v2.92l21.53 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-3">
          <path
            data-name="Rectangle 186-3"
            fill="#233762"
            d="M32.01 23.8L9.97 18.82v3.57l22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342-3"
            d="M9.71 18.43l22.56 5.1v4.27L9.71 22.65zm22 5.64l-21.49-4.88v2.93L31.75 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-3">
          <path
            data-name="Rectangle 187-3"
            fill="#233762"
            d="M32.01 27.41L9.97 22.39v3.57l22.04 5.06v-3.61z"
          />
          <path
            data-name="Path 2343-3"
            d="M9.71 22l22.56 5.13v4.27L9.71 26.22zm22 5.67l-21.49-4.9v2.92l21.53 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-3">
          <path
            data-name="Rectangle 188-3"
            fill="#233762"
            d="M32.01 31.02L9.97 25.96v3.56l22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-3"
            d="M9.71 25.57l22.56 5.18V35L9.71 29.79zm22 5.72l-21.53-5v2.92l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-3">
          <path
            data-name="Rectangle 189-3"
            fill="#233762"
            d="M32.01 34.63L9.97 29.52v3.57l22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-3"
            d="M9.71 29.14l22.56 5.23v4.26L9.71 33.35zm22 5.76l-21.53-5v2.93l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-3">
          <path
            data-name="Rectangle 190-3"
            fill="#233762"
            d="M32.01 38.24L9.97 33.09v3.57l22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-3"
            d="M9.71 32.71L32.27 38v4.27L9.71 36.92zm22 5.8l-21.53-5v2.92l21.53 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-3">
          <path
            data-name="Rectangle 191-3"
            fill="#233762"
            d="M32.01 41.86l-22.04-5.2v3.56l22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-3"
            d="M9.71 36.28l22.56 5.31v4.27L9.71 40.49zm22 5.84L10.22 37v3l21.53 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-3">
          <path
            data-name="Rectangle 192-3"
            fill="#233762"
            d="M32.01 45.49L9.97 40.25v3.57l22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-3"
            d="M9.71 39.87l22.56 5.36v4.27L9.71 44.08zm22 5.89l-21.49-5.13v2.92l21.53 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-3">
          <path
            data-name="Rectangle 193-3"
            fill="#233762"
            d="M32.01 49.11L9.97 43.82v3.57l22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-3"
            d="M9.71 43.43l22.56 5.41v4.27L9.71 47.65zm22 5.94L10.22 44.2v2.92l21.53 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-3"
          fill="#fff"
          d="M21.54 10.63l-1.44-.32v39.53l1.44.35V10.63z"
        />
      </g>
      <path fill="#233762" d="M67.81 3.42h1.26v47.15h-1.26z" />
    </svg>
  );
};
